import { cn } from '../lib/utils';
import type { OrderStatus } from '../types';

const statusConfig: Record<OrderStatus, { label: string; className: string; dot: string }> = {
  unknown: {
    label: 'Unknown',
    className: 'bg-oem-100 text-oem-500 border-oem-200',
    dot: 'bg-oem-400',
  },
  automation: {
    label: 'Automation',
    className: 'bg-status-automation/10 text-status-automation border-status-automation/20',
    dot: 'bg-status-automation',
  },
  intervention: {
    label: 'Intervention',
    className: 'bg-status-intervention/10 text-status-intervention border-status-intervention/20',
    dot: 'bg-status-intervention',
  },
  escalation: {
    label: 'Escalation',
    className: 'bg-status-escalation/10 text-status-escalation border-status-escalation/20',
    dot: 'bg-status-escalation',
  },
};

interface StatusBadgeProps {
  status: OrderStatus;
  className?: string;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, className, size = 'md' }: StatusBadgeProps) {
  const config = statusConfig[status];
  const sizeClasses = size === 'sm' 
    ? 'px-2 py-0.5 text-xs' 
    : 'px-2.5 py-1 text-sm';

  return (
    <span className={cn(
      'inline-flex items-center gap-1.5 rounded-full border font-medium',
      sizeClasses,
      config.className,
      className
    )}>
      <span className={cn('rounded-full', config.dot, size === 'sm' ? 'w-1.5 h-1.5' : 'w-2 h-2')} />
      {config.label}
    </span>
  );
}
